{
	"labelsPodatki": {
		"email": "E-Naslov",
		"naslov": "Naslov",
		"posta": "Posta",
		"kraj": "Kraj",
		"telefon": "Telefon",
		"licenca": "Licenca",
		"buttons": {
			"odpri": "Urejanje profila pilota",
			"posodobi": "posodobi"
		}
	},
	"obvestila": {
		"napakaBranja": "Napaka pri branju podatkov.",
		"napakaInputa": "Polje s kodo ne sme biti prazno!",
		"vprasanjeIzklopa": "Ali res želite izklopiti 2FA?",
		"izklopUspesen": "2FA uspešno izklopljena.",
		"vklopUspesen": "2FA uspešno nastavljen.",
		"niUjemanja": "Vnesena koda se ne ujema. Preverite vneseno kodo in poskusite znova!"
	}
}